import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BaseRouterService } from 'shared/core/data-access/router';
import { RouteFragmentEnum } from '../../enums/route-fragment/route-fragment.enum';

@Injectable({
    providedIn: 'root',
})
export class RouterService {
    #baseRouter = inject(BaseRouterService);
    #router = inject(Router);

    fine = (fineId: string) =>
        this.#baseRouter.createRoute(
            ['/', RouteFragmentEnum.FINES, fineId],
            '',
        );

    error = () =>
        this.#baseRouter.createRoute(['/', RouteFragmentEnum.ERROR], '');

    login = () =>
        this.#baseRouter.createRoute(['/', RouteFragmentEnum.LOGIN], '');

    logout = () =>
        this.#baseRouter.createRoute(['/', RouteFragmentEnum.LOGOUT], '');

    languageBelgiumEnglish = () => {
        const path = this.#router.url;

        return this.#baseRouter.createExternalRoute(`/en-BE/#${path}`, '');
    };

    languageBelgiumDutch = () => {
        const path = this.#router.url;

        return this.#baseRouter.createExternalRoute(`/nl-BE/#${path}`, '');
    };

    languageBelgiumFrench = () => {
        const path = this.#router.url;

        return this.#baseRouter.createExternalRoute(`/fr-BE/#${path}`, '');
    };

    driverChange = (fineId: string) =>
        this.#baseRouter.createRoute(
            [
                '/',
                RouteFragmentEnum.FINES,
                fineId,
                RouteFragmentEnum.DRIVER,
                RouteFragmentEnum.CREATE,
            ],
            '',
        );

    objection = (fineId: string) =>
        this.#baseRouter.createRoute(
            [
                '/',
                RouteFragmentEnum.FINES,
                fineId,
                RouteFragmentEnum.OBJECTION,
                RouteFragmentEnum.CREATE,
            ],
            '',
        );

    selection = (fineId: string) =>
        this.#baseRouter.createRoute(
            ['/', RouteFragmentEnum.FINES, fineId, RouteFragmentEnum.SELECTION],
            '',
        );

    driverWizardStep = (fineId: string, step: RouteFragmentEnum) =>
        this.#baseRouter.createRoute(
            [
                '/',
                RouteFragmentEnum.FINES,
                fineId,
                RouteFragmentEnum.DRIVER,
                RouteFragmentEnum.CREATE,
                step,
            ],
            '',
        );

    objectionWizardStep = (fineId: string, step: RouteFragmentEnum) =>
        this.#baseRouter.createRoute(
            [
                '/',
                RouteFragmentEnum.FINES,
                fineId,
                RouteFragmentEnum.OBJECTION,
                RouteFragmentEnum.CREATE,
                step,
            ],
            '',
        );
}
